import { render } from "./Editors.vue?vue&type=template&id=02447fcc"
import script from "./Editors.vue?vue&type=script&lang=js"
export * from "./Editors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__